// The member's own Hub settings (color mode, walk-me). Only the member changes them, and each change updates the
// cache as it is made, so they never go stale on their own.
import { queryOptions } from '@tanstack/react-query';

import { appDataKey } from '~/lib/app-data/keys';
import { fetchAppData } from '~/lib/app-data/fetch-app-data';
import type { getHubMetadata } from '~/services/hub-metadata-service';

export type HubMetadata = Awaited<ReturnType<typeof getHubMetadata>>;

export const hubMetadataQuery = queryOptions({
  queryKey: appDataKey('hub-metadata'),
  queryFn: () => fetchAppData<HubMetadata>('hub-metadata'),
  staleTime: Infinity,
});
